import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageService } from '../../../../services/image.service';

@Component({
    selector: 'ig-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class CardComponent {
    @Input() public class: string;
    @Input() public alt = 'picture';
    @Input() public picture: string;
    @Input() public isOperating: string;
    @Input() public containTitle = false;
    @Input() public isPromotionImage = false;
    @Input() public placeCategoryList: string[];
    @Output() public mouseenter = new EventEmitter<any>();
    @Output() public mouseleave = new EventEmitter<any>();

    constructor(public imageService: ImageService) {

    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/card/card.component.ts